import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const PartnerService = {
  getListPartner(page, perPage, name) {
    return axios.get(
      `${cleanedBackendUrl}/partner`,
      {
        params: {
          page: page,
          perPage: perPage,
          name: name
        }
      }
    );
  },
  getListPartnerAll() {
    return axios.get(
      `${cleanedBackendUrl}/partner/all`
    );
  },
  addPartner(
    username,
    email,
    phoneNumber,
    name,
    picName,
    password,
    reTypePassword,
    logo,
    bankName,
    bankAccountNo,
    bankAccountName,
    address,
    province,
    city,
    district,
    subDistrict,
    zipcode,
    cpNumber
  ) {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("email", email);
    formData.append("phonenumber", phoneNumber);
    formData.append("name", name);
    formData.append("picName", picName);
    formData.append("password", password);
    formData.append("reTypePassword", reTypePassword);
    formData.append("logo", logo ? logo.originalFile : null);
    formData.append("bankName", bankName);
    formData.append("bankAccountNo", bankAccountNo);
    formData.append("bankAccountName", bankAccountName);
    formData.append("address", address);
    formData.append("province", province);
    formData.append("city", city);
    formData.append("district", district);
    formData.append("subDistrict", subDistrict);
    formData.append("zipCode", zipcode);
    formData.append("cpNumber", cpNumber);

    return axios.post(
      `${cleanedBackendUrl}/partner`,
      formData
    );
  },
  updatePartner(
    id,
    username,
    email,
    phoneNumber,
    name,
    picName,
    logo,
    bankName,
    bankAccountNo,
    bankAccountName,
    address,
    province,
    city,
    district,
    subDistrict,
    zipcode,
    cpNumber
  ) {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("email", email);
    formData.append("phonenumber", phoneNumber);
    formData.append("name", name);
    formData.append("picName", picName);
    formData.append("logo", logo ? logo.originalFile : null);
    formData.append("bankName", bankName);
    formData.append("bankAccountNo", bankAccountNo);
    formData.append("bankAccountName", bankAccountName);
    formData.append("address", address);
    formData.append("province", province);
    formData.append("city", city);
    formData.append("district", district);
    formData.append("subDistrict", subDistrict);
    formData.append("zipCode", zipcode);
    formData.append("cpNumber", cpNumber);

    return axios.put(
      `${cleanedBackendUrl}/partner/${id}`,
      formData
    );
  },
  deletePartner(id) {
    return axios.delete(
      `${cleanedBackendUrl}/partner/${id}`
    );
  },
  updatePartnerPassword(
    id,
    password,
    reTypePassword
  ) {
    return axios.patch(
      `${cleanedBackendUrl}/partner/${id}`,
      {
        password: password,
        reTypePassword: reTypePassword
      }
    );
  },
  updatePartnerPasswordFromPartner(
    id,
    password,
    newPassword,
    confirmationPassword
  ) {
    return axios.put(
      `${cleanedBackendUrl}/partner/${id}/password`,
      {
        oldPassword: password,
        newPassword: newPassword,
        confirmationPassword: confirmationPassword
      }
    );
  }
};

export default PartnerService;